function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { CSSProperties, ReactNode, RefObject, useCallback } from 'react';
import cn from 'classnames';
import { Icon } from '../../Icon';
import DrawerBar from './Bar/DrawerBar';
import { PortalExtendableProps, Portal } from '../../Portal';
import { getDrawerSizeStyles } from './helpers/getDrawerSizeStyles';
import { useUniqId } from '../../../hooks/useUniqId';
require("./DrawerOverlay.css");
var styles = {
  "Root": "DrawerOverlay-module-Root_13Y",
  "Backdrop": "DrawerOverlay-module-Backdrop_2mC",
  "fadein": "DrawerOverlay-module-fadein_1Xj",
  "Header": "DrawerOverlay-module-Header_2yS",
  "Footer": "DrawerOverlay-module-Footer_V2j",
  "Content": "DrawerOverlay-module-Content_10e",
  "ReturnControl": "DrawerOverlay-module-ReturnControl_2WQ",
  "CloseControl": "DrawerOverlay-module-CloseControl_3PO",
  "fadeout": "DrawerOverlay-module-fadeout_2Up",
  "overlayMode": "DrawerOverlay-module-overlayMode_3SU"
};
export const DrawerOverlayPositions = {
  bottom: 'bottom',
  left: 'left',
  top: 'top',
  right: 'right'
};
export const DrawerSizeMeasures = {
  px: 'px',
  vh: 'vh',
  vw: 'vw',
  '%': '%'
};
export const DrawerOverlay = ({
  children,
  content,
  footer,
  className,
  controlRef,
  innerRef,
  isExpanded = false,
  keepMounted = true,
  onClose,
  position = DrawerOverlayPositions.bottom,
  visible = false,
  size = 'auto',
  ...props
}) => {
  const id = useUniqId('drawer-overlay');
  const _isExpanded = visible || isExpanded;
  const onBlurInputs = () => {
    if (typeof window !== 'undefined') {
      const activeForm = document.activeElement;
      activeForm.blur();
    }
  };
  const renderContent = useCallback(() => {
    if (content || footer) {
      return /*#__PURE__*/React.createElement("div", {
        onScroll: onBlurInputs
      }, /*#__PURE__*/React.createElement("div", {
        className: cn(styles.Content)
      }, content), /*#__PURE__*/React.createElement("div", {
        className: cn(styles.Footer)
      }, footer));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cn(styles.Content),
      onScroll: onBlurInputs
    }, children);
  }, [content, footer, children]);
  return /*#__PURE__*/React.createElement(Portal, {
    visible: _isExpanded,
    keepMounted: keepMounted
  }, /*#__PURE__*/React.createElement("div", _extends({
    "aria-hidden": !_isExpanded,
    className: cn(styles.Root, className, styles.overlayMode),
    ref: controlRef || innerRef
  }, props), /*#__PURE__*/React.createElement(DrawerBar, {
    onClose: onClose,
    open: _isExpanded,
    style: getDrawerSizeStyles({
      size,
      position
    }),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Header)
  }, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": _isExpanded,
    "aria-controls": id,
    className: cn(styles.CloseControl),
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    "aria-hidden": "true"
  }))), renderContent()), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Backdrop),
    onClick: onClose
  })));
};
if (process.env.NODE_ENV !== 'production') {
  DrawerOverlay.displayName = 'DrawerOverlay';
}